/* =========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
========================================================================================== */
import MsButton from '@/components/button/MsButton.vue'
import MsSplitButton from '@/components/button/MsSplitButton.vue'
import MsMenuButton from '@/components/button/MsMenuButton.vue'
import MsDropDownButton from '@/components/button/MsDropDownButton.vue'
import MsInput from '@/components/input/MsInput.vue'
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue'
import MsRadio from '@/components/radio/MsRadio.vue'
import MsSwitch from '@/components/switch'
import MsRadioGroup from '@/components/radio/MsRadioGroup.vue'
import MsDatepicker from '@/components/datepicker/MsDatePicker.vue'
import MsColorPicker from '@/components/colorpicker/MsColorPicker.vue'
import MsTextArea from '@/components/textarea/MsTextArea.vue'
// import VTooltip from "@/components/tooltip";
import MsNumber from '@/components/number/MsNumber.vue'
import MsComboBox from '@/components/combobox/MsCombobox.vue'
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum'
import MsDynamicPopup from '@/components/popup/MsDynamicPopup.vue'
import MsTabDynamic from '@/components/tab/MsTabDynamic.vue'
import MsComboboxMultiple from '@/components/combobox/MsComboboxMultipleV2.vue'

import vClickOutSide from 'click-outside-vue3'
export function useComponents (app) {
  app.component(MsButton.name, MsButton)
  app.component(MsSplitButton.name, MsSplitButton)
  app.component(MsMenuButton.name, MsMenuButton)
  app.component(MsDropDownButton.name, MsDropDownButton)
  app.component(MsInput.name, MsInput)
  app.component(MsCheckbox.name, MsCheckbox)
  app.component(MsSwitch.name, MsSwitch)
  app.component(MsRadio.name, MsRadio)
  app.component(MsRadioGroup.name, MsRadioGroup)
  app.component(MsDatepicker.name, MsDatepicker)
  app.component(MsColorPicker.name, MsColorPicker)
  app.component(MsTextArea.name, MsTextArea)
  // app.use(VTooltip);
  app.use(vClickOutSide)
  app.component(MsNumber.name, MsNumber)
  app.component(MsComboBox.name, MsComboBox)
  app.component(MsComboboxEnum.name, MsComboboxEnum)
  app.component(MsDynamicPopup.name, MsDynamicPopup)
  app.component(MsComboboxMultiple.name, MsComboboxMultiple)
  app.component(MsTabDynamic.name, MsTabDynamic)
}
